import React, { memo } from "react";
import {useFormContext} from "react-hook-form";

const HandleStyleRadioGroup = memo(
    ({ handles, path, register, formState: { isDirty }, control }) => {

        const {getValues} = useFormContext()

        const opening = getValues('opening_direction')
        return (
            <>
                {handles.map(({ name }) => (
                    <div key={name} className="group">
                        <div
                            key={name}
                            className="relative flex flex-col group-has-[:checked]:bg-[#555454] p-3"
                        >
                            {path === 'external' ? (
                            <img
                                className="size-20 object-contain"
                                src={`/assets/handles/${path}/${name}-preview.png`}
                                alt={name}
                            />
                            ) : (
                                <img
                                    className="size-20 object-contain"
                                    src={`/assets/handles/${path}/${opening}/${name.replace("_Right", "")}.png`}
                                    alt={name}
                                />
                            )}
                            <p className="text-gray-600 text-xs text-center group-has-[:checked]:text-white">
                                {name.replace(/_/g, ' ')}
                            </p>
                            {path === 'external' ? (
                                <input
                                    className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                                    type="radio"
                                    value={name}
                                    {...register(`${path}_handle_style`)}
                                />
                            ): (
                                <input
                                    className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                                    type="radio"
                                    value={name.replace("_Right", "")}
                                    {...register(`${path}_handle_style`)}
                                />
                            )}

                        </div>
                    </div>
                ))}
            </>
        );
    },
    (prevProps, nextProps) =>
        prevProps.formState.isDirty === nextProps.formState.isDirty
);
export default HandleStyleRadioGroup;
